var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col shadow-md justify-center items-center p-2 mx-2 h-auto bg-white-dark"
  }, [_c('div', {
    staticClass: "w-16 h-8 flex justify-center items-start font-bold",
    class: [_vm.trueColors || _vm.normal ? '' : 'italic']
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _vm._v(" "), _vm._l((_vm.colors), function(color, index) {
    return _c('div', {
      key: index,
      staticClass: "w-16 h-16",
      class: [_vm.trueColors ? 'swatch' : '', index === _vm.selectedIndex && _vm.trueColors ? 'selected' : ''],
      style: ({
        'background': color
      }),
      on: {
        "click": function($event) {
          _vm.toggleSelect(index)
        }
      }
    })
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af64c76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorColumn.vue
// module id = hzIq
// module chunks = 1